<template>
  <div>
    <h2>{{ article.title[locale] }}</h2>

    <p v-html="article.text[locale]"></p>

    <gallery
      :images="images"
      :index="index"
      @close="index = null"
      :options="{ displayClass: 'blueimp-gallery-display-fix' }"
    />

    <div class="gallery-container">
      <img
        :src="`${image.split('.jpg').shift()}-thumbnail.jpg`"
        class="image"
        v-for="(image, imageIndex) in images"
        @click="index = imageIndex"
      />
    </div>

    <div style="margin-bottom: 30px; text-align: right; padding-right: 25px;">
      <router-link :to="`/hireink/${article.slug}`">
        {{ $t('Gallery') }}
      </router-link>
    </div>

    <div class="separator" v-if="!noSeparator">
      <img src="~@/assets/dots.svg" alt="separator">
    </div>
  </div>
</template>

<i18n>
    {
      "de": {
        "Gallery": "Für weitere Fotos hier klicken ➜"
      },
      "en": {
        "Gallery": "See more pictures ➜"
      },
      "hu": {
        "Gallery": "További képek megtekintése ➜"
      }
    }
  </i18n>

<script>
  import Gallery from 'vue-gallery';

  export default {
    name: 'newsList',
    props: {
      article: {
        type: Object,
        required: true,
      },
      noSeparator: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        index: null,
      };
    },
    computed: {
      locale() {
        return this.$store.state.i18n.locale;
      },
      images() {
        return this.article.images
          .map(image => `${location.origin}/static/images/news/${image}`);
      },
    },
    components: {
      Gallery,
    },
  };

</script>

<style scoped>
  a {
    text-decoration: none;
    color: #eb2e4a;
    font-weight: bold;
  }

  .gallery-container {
    display: flex;
    justify-content: flex-start;
    max-width: 100vw;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .image {
    width: 270px;
    height: 270px;
    margin: 5px;
    cursor: pointer;
  }

  @media (max-width: 889px) {
    .gallery-container {
      justify-content: center;
      margin-left: -15px;
      margin-right: -15px;
    }

    .image {
      width: 512px;
      height: 512px;
      max-width: 100vw;
      max-height: 100vw;
      margin: 1px 0 1px 0;
    }
  }

  @media (min-width: 993px) and (max-width: 1269px) {
      .gallery-container {
        justify-content: center;
      }

      .image {
        width: 512px;
        height: 512px;
        margin: 1px 0 1px 0;
      }
    }

  .separator {
    text-align: center;
  }

  .separator img {
    width: 80px;
  }

</style>



// WEBPACK FOOTER //
// NewsArticle.vue?1dba5cd7